import { gql } from "graphql-request";

export const GET_POSTS_QUERY = gql`
  query GetPosts(
    $filter: String
    $pageNo: Int
    $pageSize: Int
    $order: [DynamicSortInput!]
  ) {
    getposts(
      input: {
        filter: $filter
        pageNo: $pageNo
        pageSize: $pageSize
      }
      order: $order
    ) {
      items {
        ItemId
        content
        hashtags
        authorSnapshot {
          firstName
          lastName
          profileImageUrl
          userId
        }
        mentionedUsers {
          userId
          firstName
          lastName
          profileImageUrl
          email
          displayName
        }
        commentCount
        reactionCount {
          heart
          like
          sad
          mad
          laugh
          surprise
        }
        visibility
        visibleToGroupIds
        visibleToUserIds
        groupId
        attachmentUrls
        saveCount
        CreatedDate
        CreatedBy
      }
      totalCount
      totalPages
      pageNo
      pageSize
      hasNextPage
      hasPreviousPage
    }
  }
`;


export const CREATE_POST_MUTATION = gql`
  mutation InsertPost(
    $content: String!
    $hashtags: [String]
    $mentionedUsers: [usersnapshotInput]
    $visibility: String
    $firstName: String
    $lastName: String
    $email: String
    $profileImageUrl: String
    $attachmentUrls: [String]
    $visibleToGroupIds: [String]
    $visibleToUserIds: [String]
    $score: Float
    $userId: String
    $organizationIds: [String]
    $groupId: String
  ) {
    insertpost(
      input: {
        OrganizationIds: $organizationIds
        content: $content
        hashtags: $hashtags
        mentionedUsers: $mentionedUsers
        visibility: $visibility
        attachmentUrls: $attachmentUrls
        groupId: $groupId
        visibleToGroupIds: $visibleToGroupIds
        visibleToUserIds: $visibleToUserIds
        score: $score
        commentCount: 0
        saveCount: 0
        reactionCount: {
          like: 0
          mad: 0
          surprise: 0
          sad: 0
          heart: 0
          laugh: 0
        }
        authorSnapshot: {
          firstName: $firstName
          lastName: $lastName
          email: $email
          profileImageUrl: $profileImageUrl
          userId: $userId
        }
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const UPDATE_POST_MUTATION = gql`
  mutation UpdatePost(
    $filter: String!
    $content: String
    $mentionedUsers: [usersnapshotInput]
    $hashtags: [String]
    $visibility: String
    $attachmentUrls: [String]
    $visibleToGroupIds: [String]
    $visibleToUserIds: [String]
  ) {
    updatepost(
      filter: $filter
      input: {
        content: $content
        hashtags: $hashtags
        mentionedUsers: $mentionedUsers
        visibility: $visibility
        attachmentUrls: $attachmentUrls
        visibleToGroupIds: $visibleToGroupIds
        visibleToUserIds: $visibleToUserIds
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const UPDATE_POST_SCORE_MUTATION = gql`
  mutation UpdatePost($filter: String!, $score: Float) {
    updatepost(filter: $filter, input: { score: $score }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const DELETE_POST_MUTATION = gql`
  mutation DeletePost($filter: String!) {
    deletepost(filter: $filter, input: { isHardDelete: true }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

// Bulk delete: every post created by a user (used by the user-deletion purge).
export const DELETE_MANY_POST_BY_CREATOR = gql`
  mutation DeleteManyPostByCreator($createdBy: String!) {
    deleteManypost(
      where: { CreatedBy: { eq: $createdBy } }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      itemId
      message
    }
  }
`;

// Bulk delete: every post shared in a group (used when deleting a group).
export const DELETE_MANY_POST_BY_GROUP = gql`
  mutation DeleteManyPostByGroup($groupId: String!) {
    deleteManypost(
      where: { groupId: { eq: $groupId } }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      itemId
      message
    }
  }
`;

// Reactions
export const GET_USER_REACTION_QUERY = gql`
  query GetUserReaction($filter: String!) {
    getreactions(
      input: { filter: $filter, sort: "{}", pageNo: 1, pageSize: 1 }
    ) {
      items {
        ItemId
        userId
        postId
        commentId
        type
      }
    }
  }
`;

export const GET_REACTIONS = gql`
  query GetReactions(
    $filter: String
    $sort: String
    $pageNo: Int
    $pageSize: Int
  ) {
    getreactions(
      input: {
        filter: $filter
        sort: $sort
        pageNo: $pageNo
        pageSize: $pageSize
      }
    ) {
      items {
        ItemId
        userId
        postId
        commentId
        type
        reactorName
        reactorProfileImageUrl
      }
      totalCount
      totalPages
      hasNextPage
      hasPreviousPage
    }
  }
`;

export const INSERT_REACTION_MUTATION = gql`
  mutation InsertReaction(
    $userId: String!
    $postId: String
    $type: String!
    $commentId: String
    $organizationIds: [String]
    $reactorName: String
    $reactorProfileImageUrl: String
  ) {
    insertreaction(
      input: {
        OrganizationIds: $organizationIds
        userId: $userId
        postId: $postId
        type: $type
        commentId: $commentId
        reactorName: $reactorName
        reactorProfileImageUrl: $reactorProfileImageUrl
      }
    ) {
      acknowledged
      itemId
    }
  }
`;

export const UPDATE_REACTION_MUTATION = gql`
  mutation UpdateReaction($filter: String!, $type: String!) {
    updatereaction(filter: $filter, input: { type: $type }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const DELETE_REACTION_MUTATION = gql`
  mutation DeleteReaction($filter: String!) {
    deletereaction(filter: $filter, input: { isHardDelete: true }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

// Bulk delete: every reaction made by a user (used by the user-deletion purge).
export const DELETE_MANY_REACTION_BY_USER = gql`
  mutation DeleteManyReactionByUser($userId: String!) {
    deleteManyreaction(
      where: { userId: { eq: $userId } }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      itemId
      message
    }
  }
`;

export const UPDATE_POST_REACTION_COUNT_MUTATION = gql`
  mutation UpdatePostReactionCount(
    $filter: String!
    $reactionCount: reactionCountInput!
  ) {
    updatepost(filter: $filter, input: { reactionCount: $reactionCount }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

// Comments
export const GET_COMMENTS_QUERY = gql`
  query GetComments(
    $filter: String
    $sort: String
    $pageNo: Int
    $pageSize: Int
  ) {
    getcomments(
      input: {
        filter: $filter
        sort: $sort
        pageNo: $pageNo
        pageSize: $pageSize
      }
    ) {
      totalCount
      totalPages
      hasNextPage
      hasPreviousPage
      items {
        ItemId
        postId
        parentCommentId
        content
        replyCount
        authorSnapshot {
          firstName
          lastName
          email
          profileImageUrl
        }
        reactionCount {
          like
          mad
          surprise
          sad
          heart
          laugh
        }
        CreatedDate
      }
    }
  }
`;

export const CREATE_COMMENT_MUTATION = gql`
  mutation InsertComment(
    $authorId: String!
    $postId: String!
    $parentCommentId: String
    $content: String!
    $replyCount: Int!
    $firstName: String
    $lastName: String
    $email: String
    $profileImageUrl: String
    $organizationIds: [String]
  ) {
    insertcomment(
      input: {
        OrganizationIds: $organizationIds
        authorId: $authorId
        postId: $postId
        parentCommentId: $parentCommentId
        content: $content
        replyCount: $replyCount
        authorSnapshot: {
          firstName: $firstName
          lastName: $lastName
          email: $email
          profileImageUrl: $profileImageUrl
        }
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const UPDATE_COMMENT_REACTION_COUNT_MUTATION = gql`
  mutation UpdateCommentReactionCount(
    $filter: String!
    $reactionCount: reactionCountInput!
  ) {
    updatecomment(filter: $filter, input: { reactionCount: $reactionCount }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const UPDATE_COMMENT_REPLY_COUNT_MUTATION = gql`
  mutation UpdateCommentReplyCount($filter: String!, $replyCount: Int!) {
    updatecomment(filter: $filter, input: { replyCount: $replyCount }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const UPDATE_POST_COMMENT_COUNT_MUTATION = gql`
  mutation UpdatePostCommentCount($filter: String!, $commentCount: Int!) {
    updatepost(filter: $filter, input: { commentCount: $commentCount }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const DELETE_COMMENT_MUTATION = gql`
  mutation DeleteComment($filter: String!) {
    deletecomment(filter: $filter, input: { isHardDelete: true }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

// Bulk delete: every comment authored by a user (used by the user-deletion purge).
export const DELETE_MANY_COMMENT_BY_AUTHOR = gql`
  mutation DeleteManyCommentByAuthor($authorId: String!) {
    deleteManycomment(
      where: { authorId: { eq: $authorId } }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      itemId
      message
    }
  }
`;
